export default function Repaire(props: any) {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M33.4692 30.4358C34.1242 28.8571 34.4859 27.1283 34.4859 25.3163V10.2714L20.7392 5.84375L6.99357 10.2714V25.3163C6.90547 36.9902 21.3289 43.1434 29.9154 35.3969"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.5564 15.8697C22.336 13.6372 19.0026 13.2101 16.3538 14.5847L19.1499 17.396L16.1212 20.4411L13.3251 17.6298C11.958 20.2922 12.3837 23.6447 14.6032 25.8771C16.6904 27.9748 19.7603 28.4763 22.321 27.3874L31.15 36.2655C32.1824 37.3035 33.8561 37.3025 34.8885 36.2655C35.9208 35.2275 35.9208 33.5447 34.8885 32.5067L26.0595 23.6296C27.1415 21.0549 26.6436 17.9683 24.5564 15.8697Z"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
